import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetSelfServiceFlowBreadcrumbs} from '../hooks/useGetSelfServiceFlow';
import {HelpCenterMobileNavigation} from '../shared/HelpCenterMobileNavigation';

export const SelfServiceFlowNavigation = () => {
  return (
    <DataFetcher
      request={useGetSelfServiceFlowBreadcrumbs()}
      View={HelpCenterMobileNavigation}
      Error={() => null}
      Loading={() => null}
    />
  );
};
